<template>
    <Layout>
    <PageHeader :title="title" :items="items" />
    
    <!-- Person details & top mention -->
    <div class="row mb-4">
      <div class="col-lg-12 col-sm-12">
        <div class="card h-100 ">
          <div class="card-body text-left">
              <div class="row">
                  <div class="col-sm-6">
                        <h5>{{ $t('twitter.preview') }}</h5>  
                  </div>
                  <div class="col-sm-6 text-right text-secondary">
                        <button role="button"  class="btn btn-success btn-sm w-md ml-1" @click="generateReport">
                            <i class="fa fa-file-pdf mr-1" v-if="!loading.generate"></i>
                            <i class="bx bx-loader-alt bx-spin mr-1" v-if="loading.generate"></i>
                        Download PDF
                    </button>  
                  </div>
              </div>
          </div>
        </div>
      </div>
    </div>
    <simplebar style="max-height: 70vh;">
        <vue-html2pdf
                :show-layout="true"
                :float-layout="false"
                :enable-download="enableDownload"
                :preview-modal="previewModal"
                :paginate-elements-by-height="1900"
                :filename="filename"
                :pdf-quality="2"
                :manual-pagination="true"
                pdf-format="letter"
                pdf-orientation="portrait"
                pdf-content-width="800px"
                ref="html2Pdf"
                >
                <section slot="pdf-content">
                        <!-- Person details & top mention -->
                        <div class="row mb-2">
                        <div class="col-lg-12 col-sm-12">
                            <div class="card h-100 ">
                            <div class="card-body text-left">
                                   <div class="text-center justify-content-between">
                                    <h2><img src="@/assets/images/osint-horizontal.png" alt="logo" width="100" class="mb-1" /> </h2> <h4 class="mt-1"><b>{{ $t('twitter.laporan') }}</b></h4>
                                    <hr>
                                </div>
                                <div class="row">
                                    <div class="col-sm-6">
                                        <h5>{{ $t('twitter.basic-info') }} </h5>  
                                    </div>
                                    <div class="col-sm-6 text-right text-secondary">
                                            <p><span class="text-secondary btn btn-sm btn-light mr-1">{{ $t('twitter.updated') }} {{formatDateRefresh(basicInfo.updated_at)}}</span> 
                                        </p>
                                    </div>
                                </div>
                                <div class="mb-3 mt-4">
                                    <div class="media">
                                    <img
                                    :src="basicInfo.avatar != '' ? basicInfo.avatar : 'https://img.icons8.com/ios/240/000000/user-male-circle.png'"
                                    class="mr-3 rounded-circle avatar-xl"
                                    alt="user-pic"
                                    />
                                    <div class="media-body p-1 text-center">
                                    <h6 class="mb-1">{{ $t('twitter.tweets') }}</h6>
                                    <hr>
                                    <h6>{{basicInfo.tweets}} </h6>
                                    </div>
                                    <div class="media-body p-1 text-center">
                                    <h6 class="mb-1">{{ $t('twitter.favorites') }}</h6>
                                    <hr>
                                    <h6>{{basicInfo.favorites}} </h6>
                                    </div>
                                    <div class="media-body p-1 text-center">
                                    <h6 class="mb-1 ">{{ $t('twitter.followers') }}</h6>
                                    <hr>
                                    <h6 >{{basicInfo.followers}}</h6>
                                    </div>
                                    <div class="media-body p-1 text-center">
                                    <h6 class="mb-1">{{ $t('twitter.following') }}</h6>
                                    <hr>
                                    <h6>{{basicInfo.following}} </h6>
                                    </div>
                                </div>
                                </div>
                                <div>
                                    <a :href="'https://twitter.com/'+basicInfo.username" target="_blank"><p class="text-primary">{{basicInfo.name}}    &nbsp;  <span v-if="basicInfo.private == 1" class="text-secondary align-items-center"> <i class="text-dark mdi mdi-shield-lock-outline mdi-24px"></i>  {{ $t('twitter.account-private') }} </span></p></a>
                                    <a :href="'https://twitter.com/'+basicInfo.username" target="_blank"><p class="text-secondary">  @{{basicInfo.username}} </p></a>
                                    <p>Bio</p>
                                    <p>{{basicInfo.bio}}</p>
                                    <p v-if="basicInfo.location"><i class="bx bx-map"> </i> {{basicInfo.location}}</p>
                                    <p><i class="bx bx-calendar"> </i> {{ $t('twitter.table.joint-at') }} {{basicInfo.join_date}}</p>
                                </div>

                                 <div class="row pt-4">
                                    <div class="col-sm-6">
                                        <h5>{{ $t('twitter.twitter-view.top-mention') }}</h5>
                                    </div>
                                    <div class="col-sm-6 text-right">
                                    </div>
                                </div>
                                <div class="pt-2">
                                    <div class="table-responsive mb-0">
                                    <table class="table table-sm table-bordered">
                                        <thead>
                                            <tr>
                                                <th>{{ $t('twitter.table.mention') }} </th>
                                                <th class="text-center" width="20%">{{ $t('twitter.table.total') }} </th>
                                                <th class="text-center" width="20%">{{ $t('twitter.table.percentage') }} </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(top, index) in topMention" :key="index">
                                                <td class="text-primary">{{top.user_mention}}</td>
                                                <td class="text-center">{{top.count}}</td>
                                                <td class="text-center">{{toFixed(top.percentage)}} %</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    </div>
                                </div>
                            </div>
                            </div>
                        </div>

                        </div>
                        
                        <!-- Heatmap tweets by time -->
                        <div class="html2pdf__page-break"/>
                        <div class="row mb-4">
                        <div class="col-lg-12 col-sm-12">
                            <div class="card h-100 ">
                            <div class="card-body text-left">
                                   <table class="table table-bordered py-2 mb-3">
                                    <thead>
                                          <h5 class="p-3">{{ $t('twitter.twitter-view.heat-map') }}</h5>
                                    </thead>
                                    <tbody>
                                        <apexchart type="heatmap" height="350" :options="{
                                        chart: {
                                            height: 350,
                                            type: 'heatmap',
                                        },
                                        toolbar:{
                                            show:false
                                        },
                                        dataLabels: {
                                            enabled: false
                                        },
                                        colors: ['#bf151c'],
                                        theme: {
                                            mode: theme, 
                                            palette: 'palette1', 
                                            monochrome: {
                                                enabled: false,
                                                color: '#bf151c',
                                                shadeTo: theme,
                                                shadeIntensity: 0.7
                                            },
                                        },
                                        title: {
                                            text: 'Last 200 tweets using UTC +07:00',
                                            align: 'center'
                                        },
                                    }" :series="heatmapSeries"></apexchart>
                                    </tbody>
                                    </table>     

                                    <table class="table table-bordered py-2">
                                    <thead>
                                     <h5 class="pt-4 text-center">{{ $t('twitter.twitter-view.tweets') }}</h5>
                                    </thead>
                                    <tbody >
                                        <tr class="p-4">
                                            <div v-if="sourceOptions.series == ''">
                                                <center><h6 class="pb-4 text-secondary mt-5 pt-5">{{ $t('overview.table.all.dnf') }}</h6></center> 
                                            </div>
                                            <div class="text-center p-5" v-if="sourceOptions">
                                           <apexchart
                                                class="apex-charts pt-2"
                                                dir="ltr"
                                                height="340"
                                                :series="sourceOptions.series"
                                                :options="sourceOptions.chartOptions"
                                            ></apexchart>
                                            </div>
                                        </tr>
                                    </tbody>
                                    </table>       
                            </div>
                            </div>
                        </div>
                        </div>

                        <!-- Pie sentimen analys twet by -->
                        <div class="html2pdf__page-break"/>
                        <div class="row mb-4">
                        <div class="col-lg-12 col-sm-12">
                            <div class="card h-100 ">
                            <div class="card-body text-left">
                                   <table class="table table-bordered py-2 mb-3">
                                    <thead>
                                     <h5 class="pt-5 text-center">{{ $t('twitter.twitter-view.sentimen') }}</h5>
                                    </thead>
                                    <tbody >
                                        <tr class="p-4">
                                            <div v-if="sentimenOptions.series == ''">
                                                <center><h6 class="py-5 text-secondary mt-5 pt-5">{{ $t('overview.table.all.dnf') }}</h6></center> 
                                            </div>
                                            <div class="text-center p-5" v-if="sentimenOptions.series">
                                            <apexchart
                                                class="apex-charts"
                                                dir="ltr"
                                                height="340"
                                                :series="sentimenOptions.series"
                                                :options="sentimenOptions.chartOptions"
                                             ></apexchart>
                                            </div>
                                        </tr>
                                    </tbody>
                                    </table>   
                            </div>
                            </div>
                        </div>
                        </div>  
                        
                        <!-- Word Cloud -->
                        <div class="html2pdf__page-break"/>
                        <div class="row mb-4">
                        <div class="col-lg-12 col-sm-12">
                            <div class="card h-100 ">
                            <div class="card-body text-left">
                                   <table class="table table-bordered py-2">
                                    <thead>
                                    <h5 class="p-3">{{ $t('twitter.twitter-view.word-cloud') }}</h5>
                                    </thead>
                                    <tbody >
                                         <tr class="p-4">
                                         <div v-if="wordCloud == ''">
                                                <center><h6 class="py-5 text-secondary mt-5 pt-5">{{ $t('overview.table.all.dnf') }}</h6></center> 
                                            </div>
                                            <div class="text-center p-5" v-if="wordCloud">
                                            <vue-word-cloud
                                                style="
                                                height: 480px;
                                                margin-left:3%;

                                                width: 95%;?
                                                font-family: arial, sans-serif;
                                            "
                                            :words="wordCloud"
                                            :color="([, weight]) => weight > 10 ? '#BD241E' : weight > 5 ? '#bc0505' : '#d10404'"
                                            font-family="Poppins, sans-serif"
                                            />
                                            </div>
                                            </tr>
                                    </tbody>
                                    </table>     
                            </div>
                            </div>
                        </div>
                        </div>

                        <!-- Hastag Cloud -->
                        <div class="html2pdf__page-break"/>
                        <div class="row mb-4">
                        <div class="col-lg-12 col-sm-12">
                            <div class="card h-100 ">
                            <div class="card-body text-left">
                                   <table class="table table-bordered py-2">
                                    <thead>
                                    <h5 class="p-3">{{ $t('twitter.twitter-view.hastag-cloud') }}</h5>
                                    </thead>
                                    <tbody >
                                        <tr class="p-4">
                                            <div v-if="hastagsCloud == ''">
                                                <center><h6 class="py-5 text-secondary mt-5">{{ $t('overview.table.all.dnf') }}</h6></center> 
                                            </div>
                                            <div class="text-center p-5" v-if="hastagsCloud">
                                                <vue-word-cloud
                                                        style="
                                                            height: 480px;
                                                            width: 95%;
                                                            font-family: arial, sans-serif;
                                                        "
                                                        :words="hastagsCloud"
                                                        :color="([, weight]) => weight > 25 ? '#BD241E' : weight > 15 ? '#bc0505' : '#d10404'"
                                                        font-family="Poppins, sans-serif"
                                                    />
                                            </div>
                                        </tr>
                                    </tbody>
                                    </table>     
                            </div>
                            </div>
                        </div>
                        </div>
                                      
                        <!-- Followers Following top 5 -->
                        <div class="html2pdf__page-break"/>
                        <div class="row mb-4">
                        <div class="col-lg-12 col-sm-12">
                            <div class="card h-100 ">
                            <div class="card-body text-left">
                                    <h5 class="py-2 px-0">Top 5  {{ $t('twitter.twitter-view.following') }}</h5>
                                   <table class="table table-bordered mb-5 table-sm">
                                    <thead v-if="topFollowing">
                                        <tr>
                                            <th>{{ $t('twitter.table.account') }}</th>
                                            <th class="text-center" width="20%">{{ $t('twitter.table.followers') }}</th>
                                            <th class="text-center" width="20%">{{ $t('twitter.table.following') }}</th>
                                            <th class="text-center" width="20%">Tweets</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(following, index) in topFollowing" :key="index">
                                            <td> <div class="media"> 
                                            <img :src="following.profile_img_url != '' ? following.profile_img_url : 'https://img.icons8.com/ios/240/000000/user-male-circle.png'" class="mr-3 mt-1 rounded-circle avatar-xs" alt="user-pic" />
                                            <div class="media-body">
                                                <b><a :href="'https://twitter.com/'+following.username" target="_blank" rel="noopener noreferrer">{{following.name}}</a></b> <br>
                                                <p class="text-secondary">@{{following.username}}</p> 
                                                </div>
                                            </div></td>
                                            <td class="text-center">{{following.followers}}</td>
                                            <td class="text-center">{{following.following}}</td>
                                            <td class="text-center">{{following.tweets}}</td>
                                        </tr>
                                    </tbody>
                                    </table>

                                        <h5 class="px-0">Top 5 {{ $t('twitter.twitter-view.followers') }}</h5>
                                        <table class="table table-bordered table-sm">
                                        <thead>
                                            <tr>
                                                <th>{{ $t('twitter.table.account') }}</th>
                                                <th class="text-center" width="20%">{{ $t('twitter.table.followers') }}</th>
                                                <th class="text-center" width="20%">{{ $t('twitter.table.following') }}</th>
                                                <th class="text-center" width="20%">Tweets</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(followers, index) in topFollowers" :key="index">
                                                <td> <div class="media"> 
                                                <img :src="followers.profile_img_url != '' ? followers.profile_img_url : 'https://img.icons8.com/ios/240/000000/user-male-circle.png'" class="mr-3 mt-1 rounded-circle avatar-xs" alt="user-pic" />
                                                <div class="media-body">
                                                    <b><a :href="'https://twitter.com/'+followers.username" target="_blank" rel="noopener noreferrer">{{followers.name}}</a></b> <br>
                                                    <p class="text-secondary">@{{followers.username}}</p> 
                                                    </div>
                                                </div></td>
                                                <td class="text-center">{{followers.followers}}</td>
                                                <td class="text-center">{{followers.following}}</td>
                                                <td class="text-center">{{followers.tweets}}</td>
                                            </tr>
                                        </tbody>
                                        </table>
                            </div>
                            </div>
                        </div>
                        </div>
                                     
                        <!-- Timeline tweets  -->
                        <div class="html2pdf__page-break"/>
                        <div class="row mt-4 mb-4">
                            <div class="col-lg-12 col-sm-12">
                                <div class="card">
                                    <div>
                                        <h5 class="pt-4 px-4">{{ $t('twitter.twitter-view.timeline') }} ({{ $t('twitter.last-post') }})</h5>
                                    </div>
                                    <div class="card-body">
                                    <div class="table-responsive mb-0">
                                            <table class="table table-bordered table-sm">
                                            <thead>
                                                <tr>
                                                    <th width="20%">{{ $t('twitter.table.date') }}</th>
                                                    <th>{{ $t('twitter.table.post') }}</th>
                                                    <th class="text-center" width="13%">{{ $t('twitter.table.like') }}</th>
                                                    <th class="text-center" width="15%">{{ $t('twitter.table.retweets') }}</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(tweet, index) in tableData" :key="index" style="page-break-inside: avoid;">
                                                    <td>  
                                                        <span class="text-secondary">{{formatDay(tweet.date)}},</span> <br>
                                                        <span class="text-secondary">{{formatDate(tweet.date)}}</span>
                                                    </td>
                                                    <td>{{tweet.tweets}}</td>
                                                    <td class="text-center">{{tweet.likes}}</td>
                                                    <td class="text-center">{{tweet.retweet}}</td>
                                                </tr>
                                            </tbody>
                                            </table>
                                    </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                           
                </section>
        </vue-html2pdf>
    </simplebar>
    </Layout>
</template>

<script>
import Layout from "../../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import PreferenceService from "@/helpers/preference.service.js";
import VueWordCloud from 'vuewordcloud'
import TwintService from '@/helpers/twint.service'
import SosmedService from '@/helpers/socmed.service'
import moment from 'moment';
import simplebar from "simplebar-vue";
import { ref } from 'vue'

/**
 * Profile component
 */
export default {
  page: {
    title: "Report Twitter Analys",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { Layout, PageHeader, VueWordCloud, simplebar },
  data() {
        let sentimenOptions = {
        series: [],
        chartOptions: {
            chart: {
                type: 'pie',
                height: 100,
                size:250,
                
            },
            labels: [],
            colors: [],
            legend: {
                show: true,
                position: 'bottom',
                labels: {
                colors: '#74788d',
            },
            },
            
            plotOptions: {
                pie: {
                donut: {
                        size: '2%',
                    }
                }
            }
        }
        };

        let sourceOptions = {
        series: [],
        chartOptions: {
            chart: {
                type: 'pie',
                height: 100,
                size:250
            },
            labels: [],
            colors: [
                    '#7f1d1d',
                    '#961010',
                    '#a80a0a',
                    '#bc0505',
                    '#d10404',
                    '#ea1919',
                    '#f42c2c',
                    '#f94040',
                    ],
            legend: {
                show: true,
                position: 'bottom',
                labels: {
                colors: '#74788d',
            },
            },
            
            plotOptions: {
                pie: {
                donut: {
                        size: '2%',
                    }
                }
            }
        }
        };

    return {
        items: [
            {
            text: "Home",
            href: "/"
            },
               {
            text: this.$t('twitter.twitter-view.twitter-view'),
            href: "/twiter/"+this.$route.params.id
            },
            {
            text: this.$t('twitter.twitter-view.twitter-view-report') ,
            active: true
            }
        ],
        id: this.$route.params.id,
        theme: localStorage.getItem('theme'),
        enableDownload: '',
        previewModal: '',
        filename: 'report',
        loadingupdate:false,
        loading: {
            generate: false,
            print: false
        },
        sentimenOptions,
        sourceOptions,
        title: this.$t('twitter.laporan'),
        created_at_timeline:"",
        created_at_topmention:"",
        created_at_heatmap:"",
        created_at_wordcloud:"",
        created_at_hastagcloud:"",
        created_at_sentiment:"",
        created_at_source:"",
        elastic:"",
        tophastag:[],
        wordcloud:[],
        source:[],
        heatmap:[],
        sentiment:[],
        timeline:[],
        tableData:[],
        topFollowing:[],
        topFollowers:[],
        topMention:[],
        tableDataTopHastag: [],
        tableDataTopWordCloud: [],
        totalRows: 1,
        currentPage: 1,
        perPage: 10,
        pageOptions: [10, 25, 50, 100],
        filter: null,
        filterOn: [],
        sortBy: "age",
        sortDesc: false,
        basicInfo: {
            id : '',
            name : '',
            username : '',
            bio : '',
            location : '',
            followers : '',
            following : '',
            tweets : '',
            likes : '',
            favorites : '',
            media : '',
            join_date : '',
            join_time : '',
            private : '',
            verified : '',
            avatar : '',
            updated_at: '',
        },
        wordCloud: [],
        hastagsCloud: [],
        heatmapSeries: [
            {
                name: 'Sunday',
                data: [
                    {x: '00:00',y: 0}, 
                    {x: '01:00',y: 0}, 
                    {x: '03:00',y: 0}, 
                    {x: '04:00',y: 0},
                    {x: '05:00',y: 0}, 
                    {x: '06:00',y: 0}, 
                    {x: '07:00',y: 0},
                    {x: '08:00',y: 0}, 
                    {x: '09:00',y: 0}, 
                    {x: '10:00',y: 0},
                    {x: '11:00',y: 0}, 
                    {x: '12:00',y: 0}, 
                    {x: '13:00',y: 0},
                    {x: '14:00',y: 0}, 
                    {x: '15:00',y: 0}, 
                    {x: '16:00',y: 0},
                    {x: '17:00',y: 0}, 
                    {x: '18:00',y: 0}, 
                    {x: '19:00',y: 0},
                    {x: '20:00',y: 0}, 
                    {x: '21:00',y: 0}, 
                    {x: '22:00',y: 0},
                    {x: '23:00',y: 0}, 
                    {x: '24:00',y: 0}
                ]
            },
            {
                name: 'Monday',
                data: [
                    {x: '00:00',y: 0}, 
                    {x: '01:00',y: 0}, 
                    {x: '03:00',y: 0}, 
                    {x: '04:00',y: 0},
                    {x: '05:00',y: 0}, 
                    {x: '06:00',y: 0}, 
                    {x: '07:00',y: 0},
                    {x: '08:00',y: 0}, 
                    {x: '09:00',y: 0}, 
                    {x: '10:00',y: 0},
                    {x: '11:00',y: 0}, 
                    {x: '12:00',y: 0}, 
                    {x: '13:00',y: 0},
                    {x: '14:00',y: 0}, 
                    {x: '15:00',y: 0}, 
                    {x: '16:00',y: 0},
                    {x: '17:00',y: 0}, 
                    {x: '18:00',y: 0}, 
                    {x: '19:00',y: 0},
                    {x: '20:00',y: 0}, 
                    {x: '21:00',y: 0}, 
                    {x: '22:00',y: 0},
                    {x: '23:00',y: 0}, 
                    {x: '24:00',y: 0}
                ]
            },
            {
                name: 'Tuesday',
                data: [
                    {x: '00:00',y: 0}, 
                    {x: '01:00',y: 0}, 
                    {x: '03:00',y: 0}, 
                    {x: '04:00',y: 0},
                    {x: '05:00',y: 0}, 
                    {x: '06:00',y: 0}, 
                    {x: '07:00',y: 0},
                    {x: '08:00',y: 0}, 
                    {x: '09:00',y: 0}, 
                    {x: '10:00',y: 0},
                    {x: '11:00',y: 0}, 
                    {x: '12:00',y: 0}, 
                    {x: '13:00',y: 0},
                    {x: '14:00',y: 0}, 
                    {x: '15:00',y: 0}, 
                    {x: '16:00',y: 0},
                    {x: '17:00',y: 0}, 
                    {x: '18:00',y: 0}, 
                    {x: '19:00',y: 0},
                    {x: '20:00',y: 0}, 
                    {x: '21:00',y: 0}, 
                    {x: '22:00',y: 0},
                    {x: '23:00',y: 0}, 
                    {x: '24:00',y: 0}
                ]
            },
            {
                name: 'Wednesday',
                data: [
                    {x: '00:00',y: 0}, 
                    {x: '01:00',y: 0}, 
                    {x: '03:00',y: 0}, 
                    {x: '04:00',y: 0},
                    {x: '05:00',y: 0}, 
                    {x: '06:00',y: 0}, 
                    {x: '07:00',y: 0},
                    {x: '08:00',y: 0}, 
                    {x: '09:00',y: 0}, 
                    {x: '10:00',y: 0},
                    {x: '11:00',y: 0}, 
                    {x: '12:00',y: 0}, 
                    {x: '13:00',y: 0},
                    {x: '14:00',y: 0}, 
                    {x: '15:00',y: 0}, 
                    {x: '16:00',y: 0},
                    {x: '17:00',y: 0}, 
                    {x: '18:00',y: 0}, 
                    {x: '19:00',y: 0},
                    {x: '20:00',y: 0}, 
                    {x: '21:00',y: 0}, 
                    {x: '22:00',y: 0},
                    {x: '23:00',y: 0}, 
                    {x: '24:00',y: 0}
                ]
            },
            {
                name: 'Thursday',
                data: [
                    {x: '00:00',y: 0}, 
                    {x: '01:00',y: 0}, 
                    {x: '03:00',y: 0}, 
                    {x: '04:00',y: 0},
                    {x: '05:00',y: 0}, 
                    {x: '06:00',y: 0}, 
                    {x: '07:00',y: 0},
                    {x: '08:00',y: 0}, 
                    {x: '09:00',y: 0}, 
                    {x: '10:00',y: 0},
                    {x: '11:00',y: 0}, 
                    {x: '12:00',y: 0}, 
                    {x: '13:00',y: 0},
                    {x: '14:00',y: 0}, 
                    {x: '15:00',y: 0}, 
                    {x: '16:00',y: 0},
                    {x: '17:00',y: 0}, 
                    {x: '18:00',y: 0}, 
                    {x: '19:00',y: 0},
                    {x: '20:00',y: 0}, 
                    {x: '21:00',y: 0}, 
                    {x: '22:00',y: 0},
                    {x: '23:00',y: 0}, 
                    {x: '24:00',y: 0}
                ]
            },
            {
                name: 'Friday',
                data: [
                    {x: '00:00',y: 0}, 
                    {x: '01:00',y: 0}, 
                    {x: '03:00',y: 0}, 
                    {x: '04:00',y: 0},
                    {x: '05:00',y: 0}, 
                    {x: '06:00',y: 0}, 
                    {x: '07:00',y: 0},
                    {x: '08:00',y: 0}, 
                    {x: '09:00',y: 0}, 
                    {x: '10:00',y: 0},
                    {x: '11:00',y: 0}, 
                    {x: '12:00',y: 0}, 
                    {x: '13:00',y: 0},
                    {x: '14:00',y: 0}, 
                    {x: '15:00',y: 0}, 
                    {x: '16:00',y: 0},
                    {x: '17:00',y: 0}, 
                    {x: '18:00',y: 0}, 
                    {x: '19:00',y: 0},
                    {x: '20:00',y: 0}, 
                    {x: '21:00',y: 0}, 
                    {x: '22:00',y: 0},
                    {x: '23:00',y: 0}, 
                    {x: '24:00',y: 0}
                ]
            },
            {
                name: 'Saturday',
                data: [
                    {x: '00:00',y: 0}, 
                    {x: '01:00',y: 0}, 
                    {x: '03:00',y: 0}, 
                    {x: '04:00',y: 0},
                    {x: '05:00',y: 0}, 
                    {x: '06:00',y: 0}, 
                    {x: '07:00',y: 0},
                    {x: '08:00',y: 0}, 
                    {x: '09:00',y: 0}, 
                    {x: '10:00',y: 0},
                    {x: '11:00',y: 0}, 
                    {x: '12:00',y: 0}, 
                    {x: '13:00',y: 0},
                    {x: '14:00',y: 0}, 
                    {x: '15:00',y: 0}, 
                    {x: '16:00',y: 0},
                    {x: '17:00',y: 0}, 
                    {x: '18:00',y: 0}, 
                    {x: '19:00',y: 0},
                    {x: '20:00',y: 0}, 
                    {x: '21:00',y: 0}, 
                    {x: '22:00',y: 0},
                    {x: '23:00',y: 0}, 
                    {x: '24:00',y: 0}
                ]
            }
        ]
    };
  },
   computed: {
    rows() {
      return this.tableData.length;
    }
},
   methods:{
    getPreferences(){
        PreferenceService.getAllElastic()
        .then((response) => {
            this.elastic = response.data.data[0].ip_address;
            this.getUserBasicInfo();
            this.getMention();
            this.getUserTimeline();
            this.getTopFollow();
            this.getHeatMap();
            this.getSentimentAnalys();
            this.getSource();
            this.getWordCloud();
            this.getHastagsCloud();
        })
        .catch((err) => {
            console.log(err);
        });
    },

    generateReport () {
        this.loading.generate = true;
        this.enableDownload = true;
        this.previewModal = false;
        this.filename = 'report twitter '+ this.id;
        setTimeout(() => {
            this.loading.generate = false;
            this.$refs.html2Pdf.generatePdf();
        }, 1000);
    },
    getUserBasicInfo(){
        SosmedService.detailTwitter(this.id)
        .then(response => {
            this.basicInfo.id = response.data.data.user_id;
            this.basicInfo.name = response.data.data.name;
            this.basicInfo.username = response.data.data.account;
            this.basicInfo.bio = response.data.data.bio;
            this.basicInfo.location = response.data.data.location;
            this.basicInfo.followers = response.data.data.followers;
            this.basicInfo.following = response.data.data.following;
            this.basicInfo.tweets = response.data.data.tweets;
            this.basicInfo.likes = response.data.data.likes;
            this.basicInfo.favorites = response.data.data.favorites;
            this.basicInfo.media = response.data.data.media;
            this.basicInfo.join_date = response.data.data.join_at;
            this.basicInfo.private = response.data.data.is_private;
            this.basicInfo.verified = response.data.data.is_verified;
            this.basicInfo.avatar = response.data.data.avatar;
            this.basicInfo.updated_at = response.data.data.updated_at;
        })
        .catch(err => {
            console.log('basic err ->',err);
        });
    },
  
    // timeline
    getUserTimeline(){
        TwintService.getTimelineElastic(this.elastic, this.id)
        .then(response => {
            this.tableData = response.data._source.timeline;
            this.created_at_timeline = response.data._source.created_at;
            this.sortingArray()
        })
        .catch(err => {
            if(err == "Error: Request failed with status code 404"){
                //  this.getUserTimelineTwint();
            } else {
                console.log(err);
            }
        });
    },
    sortingArray(){
      const array = this.tableData;
      const sortedArray  = array.sort((a,b) => new moment(b.date).format('YYYYMMDDhhmmss') - new moment(a.date).format('YYYYMMDDhhmmss'));
      this.tableData = sortedArray.slice(0,49);
    },
    

    // top mention
    getMention(){
        TwintService.getMentionsElastic(this.elastic, this.id)
        .then(response => {
            this.topMention =  response.data._source.topmention;
            this.created_at_topmention = response.data._source.created_at;
        })
        .catch(err => {
            if(err == "Error: Request failed with status code 404"){
                // this.getMentionTwint();
            } else {
                console.log(err);
            }
        });
    },

    // followers following
    getTopFollow(){
        TwintService.getFollowElastic(this.elastic, this.id)
        .then(response => {
            this.topFollowers =  response.data._source.followers;
            this.topFollowing =  response.data._source.following;
        })
        .catch(err => {
            if(err == "Error: Request failed with status code 404"){
                this.getTopFollowingTwint();
                this.getTopFollowersTwint();
            } else {
                console.log(err);
            }
        });
    },

    //heatmap
    getHeatMap(){
        TwintService.getHeatMapElastic(this.elastic, this.id)
        .then(response => {
             this.created_at_heatmap = response.data._source.created_at;
             response.data._source.heatmap.forEach(element => {
                this.heatmapSeries.forEach(series => {
                    if(element.day == series.name){
                        series.data.forEach(d => {
                            if (d.x == element.hour+':00') {
                                d.y = element.count
                            }
                        });
                        // series.data.push({x: element.hour+':00', y:element.count})
                    }
                });
            });
        })
        .catch(err => {
            if(err == "Error: Request failed with status code 404"){
                // this.getHeatMapTwint();
            } else {
                console.log(err);
            }
        });
    },
    
    // sentimen analys
    getSentimentAnalys(){
        TwintService.SentimentAnalysElastic(this.elastic, this.id)
        .then(response => {
            this.created_at_sentiment = response.data._source.created_at;
            response.data._source.sentiment.forEach(event => {
            this.sentimenOptions.chartOptions.labels.push(event.sentiment)
            this.sentimenOptions.chartOptions.colors.push(event.color)
            this.sentimenOptions.series.push(event.count)
            // console.log(event.count);
        });
        })
        .catch(err => {
              if(err == "Error: Request failed with status code 404"){
                // this.getSentimentAnalysTwint();
            } else {
                console.log(err);
            }
        });
    },
    
    // source 
    getSource(){
        TwintService.getSourceElastic(this.elastic, this.id)
        .then(response => {
            this.created_at_source = response.data._source.created_at;
            response.data._source.source.forEach(event => {
            this.sourceOptions.chartOptions.labels.push(event.source)
            this.sourceOptions.series.push(event.count)
        });
        })
        .catch(err => {
            if(err == "Error: Request failed with status code 404"){
                // this.getSourceTwint();
            } else {
                console.log(err);
            }
        });
    },

    // wordcloud
    getWordCloud(){
        TwintService.getWordCloudElastic(this.elastic, this.id)
        .then(response => {
            this.created_at_wordcloud = response.data._source.created_at;
            response.data._source.wordcloud.forEach((element, i) => {
                this.wordCloud.push([element.word, element.count])
                if (i <= 9) {
                    this.tableDataTopWordCloud.push({'wordCloud': element.word, 'total': element.count, 'percentage': parseFloat(element.percentage).toFixed(0)+'%'})
                }
            });
        })
        .catch(err => {
            if(err == "Error: Request failed with status code 404"){
                // this.getWordCloudTwint();
            } else {
                console.log(err);
            }
        })
    },

    // hastag
    getHastagsCloud(){
        TwintService.getHastagsElastic(this.elastic, this.id)
        .then(response => {
           this.created_at_hastagcloud = response.data._source.created_at;
           response.data._source.tophastag.forEach(element => {
                this.hastagsCloud.push([element.hastags, element.count])
                this.tableDataTopHastag.push({'hastag': element.hastags, 'total': element.count, 'percentage': parseFloat(element.percentage).toFixed(0)+'%'})
            });
        })
        .catch(err => {
            if(err == "Error: Request failed with status code 404"){
                // this.getHastagsCloudTwint();
            } else {
                console.log(err);
            }
        });
    },
    
    formatDate(value){
      return moment(value).format("DD MMM YYYY, hh:mm");
    },
     formatDateRefresh(value){
      return moment(value).format("YYYY-MM-DD, hh:mm");
    },
    formatDay(value){
      return moment(value).format("dddd");
    },
    toFixed(value){
      return value.toFixed(0);
    },
    },
    mounted(){
        this.totalRows = this.items.length;
        this.getPreferences();
    }
};
</script>

<style scoped>
/* .card{
  border: 2px solid #f1f1f1;
} */
.my-custom-scrollbar {
position: relative;
height: 500px;
overflow: auto;
}
.table-wrapper-scroll-y {
display: block;
}
</style>